// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var DialAction_Enum;
(function (DialAction_Enum) {
    DialAction_Enum["NONE"] = "NONE";
    DialAction_Enum["OPT_OUT"] = "OPT_OUT";
    DialAction_Enum["CONFIRM_APPOINTMENT"] = "CONFIRM_APPOINTMENT";
    DialAction_Enum["REPEAT_MESSAGE"] = "REPEAT_MESSAGE";
})(DialAction_Enum || (DialAction_Enum = {}));
export var DialAction_Enum_index;
(function (DialAction_Enum_index) {
    DialAction_Enum_index[DialAction_Enum_index["NONE"] = 0] = "NONE";
    DialAction_Enum_index[DialAction_Enum_index["OPT_OUT"] = 1] = "OPT_OUT";
    DialAction_Enum_index[DialAction_Enum_index["CONFIRM_APPOINTMENT"] = 2] = "CONFIRM_APPOINTMENT";
    DialAction_Enum_index[DialAction_Enum_index["REPEAT_MESSAGE"] = 3] = "REPEAT_MESSAGE";
})(DialAction_Enum_index || (DialAction_Enum_index = {}));
export var MetadataType_Enum;
(function (MetadataType_Enum) {
    MetadataType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    MetadataType_Enum["SCHEDULED_MESSAGE_ID"] = "SCHEDULED_MESSAGE_ID";
    MetadataType_Enum["AUTO_MESSAGING_RULE_ID"] = "AUTO_MESSAGING_RULE_ID";
    MetadataType_Enum["APPOINTMENT_ID"] = "APPOINTMENT_ID";
    MetadataType_Enum["SOURCE_SYSTEM_MESSAGE_ID"] = "SOURCE_SYSTEM_MESSAGE_ID";
})(MetadataType_Enum || (MetadataType_Enum = {}));
export var MetadataType_Enum_index;
(function (MetadataType_Enum_index) {
    MetadataType_Enum_index[MetadataType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    MetadataType_Enum_index[MetadataType_Enum_index["SCHEDULED_MESSAGE_ID"] = 1] = "SCHEDULED_MESSAGE_ID";
    MetadataType_Enum_index[MetadataType_Enum_index["AUTO_MESSAGING_RULE_ID"] = 2] = "AUTO_MESSAGING_RULE_ID";
    MetadataType_Enum_index[MetadataType_Enum_index["APPOINTMENT_ID"] = 3] = "APPOINTMENT_ID";
    MetadataType_Enum_index[MetadataType_Enum_index["SOURCE_SYSTEM_MESSAGE_ID"] = 4] = "SOURCE_SYSTEM_MESSAGE_ID";
})(MetadataType_Enum_index || (MetadataType_Enum_index = {}));
